import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FiEdit } from 'react-icons/fi';
import { useIntl } from 'react-intl';

import { UserContext } from '~contexts/user';
import { DAYS } from '~src/constants';

import Button from '~components/button';

const WorkerDetails = () => {
  const intl = useIntl();

  const { user } = useContext(UserContext);
  const { operations } = user;
  const { address, minimumRate, maxTravelDistance, timeframes, languages } =
    operations;

  return (
    <>
      {/* ADDRESS */}
      {address && address.address ? (
        <div className="c-group c-group--large">
          <div className="c-group__label">
            {intl.formatMessage({
              id: 'containers.account.worker-offer.address.label',
              defaultMessage: 'Address',
            })}
          </div>
          <div className="c-group__value">
            <div className="c-account__value">{address.address}</div>
          </div>
        </div>
      ) : null}

      {/* MINIMUM RATE */}
      {minimumRate && (
        <div className="c-group c-group--large">
          <div className="c-group__label">
            {intl.formatMessage({
              id: 'containers.account.worker-offer.minimum-rate.label',
              defaultMessage: 'Minimum rate',
            })}
          </div>
          <div className="c-group__value">
            <div className="c-account__value">
              {intl.formatMessage(
                {
                  id: 'containers.account.worker-offer.minimum-rate.value',
                  defaultMessage: '{amount} per hour',
                },
                {
                  amount: intl.formatNumber(minimumRate?.amount / 100, {
                    style: 'currency',
                    currency: minimumRate?.currency,
                  }),
                }
              )}
            </div>
            <div className="c-account__desc">
              {intl.formatMessage({
                id: 'containers.account.worker-offer.minimum-rate.description',
                defaultMessage:
                  'We take into account what you want to receive per hour and only introduce customers up from this hourly rate',
              })}
            </div>
          </div>
        </div>
      )}

      {/* TRAVEL DISTANCE */}
      <div className="c-group c-group--large">
        <div className="c-group__label">
          {intl.formatMessage({
            id: 'containers.account.worker-offer.maximum-distance.label',
            defaultMessage: 'Travel distance',
          })}
        </div>
        <div className="c-group__value">
          {intl.formatMessage(
            {
              id: 'containers.account.worker-offer.maximum-distance.value',
              defaultMessage:
                '{distance, plural, =1 {# kilometer} other {# kilometers}}',
            },
            {
              distance: maxTravelDistance,
            }
          )}
        </div>
      </div>

      {/* AVAILABILITY */}
      <div className="c-group c-group--large">
        <div className="c-group__label">
          {intl.formatMessage({
            id: 'containers.account.worker-offer.availability.label',
            defaultMessage: 'Availability',
          })}
        </div>
        <div className="c-group__value">
          <div className="c-account__value">
            {!timeframes ? '-' : null}

            {timeframes &&
              DAYS.map((day) =>
                timeframes.indexOf(day) >= 0
                  ? intl.formatMessage({ id: `days.long.${day}` })
                  : false
              ).filter(Boolean).join(', ')}
          </div>
        </div>
      </div>

      {/* LANGUAGES */}
      <div className="c-group c-group--large">
        <div className="c-group__label">
          {intl.formatMessage({
            id: 'containers.account.worker-offer.languages.label',
            defaultMessage: 'Languages',
          })}
        </div>
        <div className="c-group__value">
          <div className="c-account__value">
            {languages &&
              languages
                .map((d) => intl.formatMessage({ id: `languages.${d}` }))
                .join(', ')}
          </div>
        </div>
      </div>
    </>
  );
};

const WorkerNoOperations = () => {
  const intl = useIntl();

  return (
    <div>
      <p>
        {intl.formatMessage({
          id: 'containers.account.worker-offer.no-offer.content',
          defaultMessage: 'You have no offer yet!',
        })}
      </p>
      <Link to="/edit-offer">
        <Button className="c-btn--secondary">
          {intl.formatMessage({
            id: 'containers.account.worker-offer.no-offer.button',
            defaultMessage: 'Create offer',
          })}
        </Button>
      </Link>
    </div>
  );
};

const WorkerOffer = () => {
  const intl = useIntl();

  const { user } = useContext(UserContext);
  const { operations } = user;

  return (
    <div className="c-box" data-cy="qa-preferences">
      <div className="c-box__content">
        <div className="c-editable">
          <div className="c-editable__content">
            <h3 className="l-headline--tertiary c-box__headline">
              {intl.formatMessage({
                id: 'containers.account.worker-offer.headline',
                defaultMessage: 'My offer',
              })}
            </h3>
          </div>
          <Link
            to="/edit-offer"
            className="c-editable__button"
            data-cy="c-worker-offer-editable__button"
          >
            <FiEdit />
          </Link>
        </div>

        {!operations?.address || !operations?.address?.place_id ? (
          <WorkerNoOperations />
        ) : (
          <WorkerDetails />
        )}
      </div>
    </div>
  );
};

export default WorkerOffer;
